/* eslint-disable react/jsx-closing-bracket-location */
import * as React from 'react'
import MobileStoreImage from './MobileStoreImage'
import NavigationList from './NavigationList'
import PaymentMethodImage from './PaymentMethodImage'
import PropTypes from 'prop-types'

import styled from 'styled-components'

const TopFooterContainer = styled.div`
  border-bottom: 1px solid hsla(0, 0%, 40%, .25);
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 35px;
  padding: 0px 32px;
  padding-bottom: 35px;

  @media only screen and (min-width: 992px) {
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
    margin: 0px auto 20px;
    padding: 0px 0px 58px;
  }
`

const NavigationLists = styled.div`
  display: flex;
  flex-direction: column;

  & h3{
    color: #343A4F;
  }

  @media only screen and (min-width: 992px) {
    flex-direction: row;

    & ul:first-child {
      margin-right: 110px;
    }

    & ul:nth-child(2) {
      margin-right: 134px;
    }
  }
`

const AdditionalInformation = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

`
const PaymentMethods = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`

const MobileStores = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 24px;
`
const AppPromotionText = styled.span`
  color: #00518E;
  font-size: 14px;
  line-height: 20px;
  align-self: start;
  margin-right: 12px;

  @media only screen and (min-width: 992px) {
    align-self: end;
  }
`
const AppPromotionTextBold = styled( AppPromotionText )`
  font-weight: 600;
`


const TopFooter = ( { aboutTag, contactMail, contactUs, mobileStores, ourProducts, paymentMethods } ) => {
  return (
    <TopFooterContainer>
      <NavigationLists>
        <NavigationList { ...ourProducts } />
        <NavigationList { ...aboutTag } />
        <NavigationList { ...contactUs } />
      </NavigationLists>

      <AdditionalInformation>
        <PaymentMethods>
          {
            paymentMethods && paymentMethods.map( ( paymentMethod ) => {
              return <PaymentMethodImage
                key={ paymentMethod.id }
                { ...paymentMethod }
              />
            } )
          }
        </PaymentMethods>

        <AppPromotionText>Já é uma pessoa associada?
        </AppPromotionText>
        <AppPromotionTextBold>
          Use nosso aplicativo.
        </AppPromotionTextBold>
        <MobileStores>
          {
            mobileStores && mobileStores.map( ( store ) => {
              return <MobileStoreImage
                key={ store.id }
                { ...store }
              />
            } )
          }
        </MobileStores>
        <NavigationList { ...contactMail } />
      </AdditionalInformation>
    </TopFooterContainer>
  )
}

TopFooter.propTypes = {
  'aboutTag': PropTypes.object.isRequired,
  'contactMail': PropTypes.object.isRequired,
  'contactUs': PropTypes.object.isRequired,
  'mobileStores': PropTypes.array.isRequired,
  'ourProducts': PropTypes.object.isRequired,
  'paymentMethods': PropTypes.array.isRequired
}

export default TopFooter
